import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Action } from "../../internal/Action.js";
/**
 * @description Applies a cartoon effect to an image.
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var CartoonifyEffect = /*#__PURE__*/function (_Action) {
  _inherits(CartoonifyEffect, _Action);

  var _super = _createSuper(CartoonifyEffect);

  function CartoonifyEffect(effectName, strength) {
    var _this;

    _classCallCheck(this, CartoonifyEffect);

    // We don't pass level in the constructor, we'll build it in the prepareParam
    _this = _super.call(this);
    _this._actionModel = {};
    _this.cartoonifyStrength = strength;
    _this.effectName = effectName;
    _this._actionModel.actionType = effectName;
    return _this;
  }
  /**
   * @description Sets the thickness of the lines.
   * @param {number} lineStrength The thickness of the lines. (Range: 0 to 100, Server default: 50)
   * @return {this}
   */


  _createClass(CartoonifyEffect, [{
    key: "lineStrength",
    value: function lineStrength(_lineStrength) {
      this.cartoonifyStrength = _lineStrength;
      this._actionModel.lineStrength = _lineStrength;
      return this;
    }
    /**
     * @description Achieves a black and white cartoon effect.
     * @return {this}
     */

  }, {
    key: "blackwhite",
    value: function blackwhite() {
      this._actionModel.blackAndWhite = true;
      this.colorReduction = 'bw';
      return this;
    }
    /**
     * @description
     * Sets the decrease in the number of colors and corresponding saturation boost of the remaining colors. <br/>
     * Higher reduction values result in a less realistic look.
     * @param {number } level The decrease in the number of colors and corresponding saturation boost of the remaining colors. (Range: 0 to 100, Server default: automatically adjusts according to the line_strength value). Set to 'bw' for a black and white cartoon effect.
     * @return {this}
     */

  }, {
    key: "colorReductionLevel",
    value: function colorReductionLevel(level) {
      this._actionModel.colorReductionLevel = level;
      this.colorReduction = level;
      return this;
    }
  }, {
    key: "prepareQualifiers",
    value: function prepareQualifiers() {
      this.addQualifier(new Qualifier('e', new QualifierValue([this.effectName, this.cartoonifyStrength, this.colorReduction])));
      return;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var actionType = actionModel.actionType,
          lineStrength = actionModel.lineStrength,
          blackAndWhite = actionModel.blackAndWhite,
          colorReductionLevel = actionModel.colorReductionLevel; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(actionType, lineStrength);
      blackAndWhite && result.blackwhite();
      colorReductionLevel && result.colorReductionLevel(colorReductionLevel);
      lineStrength && result.lineStrength(lineStrength);
      return result;
    }
  }]);

  return CartoonifyEffect;
}(Action);

export { CartoonifyEffect };